import React, { useState, useContext, useEffect, useRef } from 'react';
import { Dimensions, View, Text, TouchableOpacity, StyleSheet } from 'react-native-web';
import { useTranslation } from 'react-i18next';

import { fontColorWhite } from '../../../style/css/CmnStyle';
import { hpContext } from '../../hp/HPContext';
const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

function ChangeLanguage(props) {
  const { t, i18n } = useTranslation();

  const isWide = useContext(hpContext).isWide;
  const langCode = useContext(hpContext).langCode;
  const setLangCode = useContext(hpContext).setLangCode;

  const activeBtnColor = '#FF4736';
  const disActiveBtnColor = 'gray';


  // 英語
  const onPressEn = () => {
    setLangCode('en');
  }
  // 日本語
  const onPressJa = () => {
    setLangCode('ja');
  }


  const styles = StyleSheet.create({
    container: {
      position: 'fixed',
      bottom: isWide? 30 : 10,
      right: isWide? 30 : 15,
      zIndex: 10,
    },
    btn: {
      paddingHorizontal: isWide? 20 : 10,
      paddingVertical: isWide? 7 : 5,
    },
    txt: {
      textAlign: 'center',
      color: fontColorWhite,
      fontSize: isWide? '1rem' : '0.8rem',
    },
  });


  return (
      <View style={styles.container}>

        <TouchableOpacity
          style={[
            styles.btn,
            {backgroundColor : langCode=='en'? activeBtnColor : disActiveBtnColor},
            {borderTopLeftRadius: 10},
            {borderTopRightRadius: 10},
          ]}
          onPress={onPressEn}
        >
          <Text style={styles.txt}>
            {t('language.en')}
          </Text>
        </TouchableOpacity>

        <TouchableOpacity
          style={[
            styles.btn,
            {backgroundColor : langCode=='ja'? activeBtnColor : disActiveBtnColor},
            {borderBottomLeftRadius: 10},
            {borderBottomRightRadius: 10},
          ]}
          onPress={onPressJa}
        >
          <Text style={styles.txt}>
            {t('language.ja')}
          </Text>
        </TouchableOpacity>
      </View>
  );
}


export default ChangeLanguage;